export class Facets {
  count: number;
  [index: string]: number | Facet;

  constructor() {
    this.count = 0;
  }
}

export class Facet {
  buckets: Array<Bucket>;
  missing: Bucket | undefined;
  count: number | undefined;

  constructor() {
    this.buckets = [];
  }
}

export class Bucket {
  // required
  val: string;
  label: string;
  count: number;

  // optional UI/meta
  checked?: 'checked' | '';
  filtered?: boolean;

  // Timeout metadata
  timed_out?: boolean;
  search_time?: number;

  // Range facet helpers (so no @ts-ignore needed)
  rangeLabel?: string;
  rangeFilter?: string;

  constructor() {
    this.val = '';
    this.label = '';
    this.count = 0;
    this.checked = '';
    this.filtered = false;
  }
}
